import { api } from "..";

import { QueryProps } from "@/types/Api";
import { Selection, SportEvent } from "@/types/SportsApiResponses";

interface Params {
  lang: string;
}

export interface PreviousCouponResponse {
  selections: Selection[];
  sportEvents: SportEvent[];
}

export const getLastCoupon = async (
  props: QueryProps<Params>
): Promise<PreviousCouponResponse> => {
  const res = await api.client.get(`/selections-new/previous-coupon`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
